/* Post Archive.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "../../../sass/layouts/cpt_templates/archive-post.scss";
